import { __assign, __awaiter, __generator } from "tslib";
import React, { memo, useCallback, useContext, useEffect, useMemo, useRef, } from 'react';
import { FormSpy } from 'react-final-form';
import diff from 'object-diff';
import throttle from 'lodash.throttle';
import stringify from 'fast-safe-stringify';
import { FormContext } from './FormContext';
function customDiff(obj1, obj2, skipFields) {
    if (skipFields === void 0) { skipFields = []; }
    if (skipFields.length === 0) {
        return diff(obj1, obj2);
    }
    var copyObj1 = __assign({}, obj1);
    var copyObj2 = __assign({}, obj2);
    skipFields.forEach(function (field) {
        delete copyObj1[field];
        delete copyObj2[field];
    });
    return diff(copyObj1, copyObj2);
}
export var AutoSave = memo(function (_a) {
    var onAutoSave = _a.onAutoSave, values = _a.values, setFieldData = _a.setFieldData, _b = _a.autoSaveThrottleDelay, autoSaveThrottleDelay = _b === void 0 ? 5000 : _b;
    var skipFieldsOnAutoSave = useContext(FormContext).skipFieldsOnAutoSave;
    var saveRef = useRef(onAutoSave);
    var valuesRef = useRef(values);
    var saveCallback = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, saveRef.current(valuesRef.current)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var throttledSave = useMemo(function () {
        return throttle(saveCallback, autoSaveThrottleDelay, {
            leading: false,
        });
    }, [saveCallback, autoSaveThrottleDelay]);
    useEffect(function () {
        var _a;
        var diffObject = customDiff(valuesRef.current, values, skipFieldsOnAutoSave);
        if ((_a = Object.keys(diffObject)) === null || _a === void 0 ? void 0 : _a.length) {
            throttledSave();
        }
    }, [throttledSave, values, saveCallback, skipFieldsOnAutoSave]);
    useEffect(function () {
        saveRef.current = onAutoSave;
        valuesRef.current = values;
    }, [setFieldData, onAutoSave, values]);
    return null;
}, function (prevProps, nextProps) {
    try {
        return stringify(prevProps) === stringify(nextProps);
    }
    catch (e) {
        console.warn("AutoSave: ".concat(e));
        return false;
    }
});
AutoSave.displayName = 'AutoSave';
export default (function (props) {
    var onAutoSave = props.onAutoSave, autoSaveThrottleDelay = props.autoSaveThrottleDelay;
    return (React.createElement(FormSpy, { subscription: {
            values: true,
            dirty: true,
        }, render: function (renderProps) { return (React.createElement(AutoSave, { values: renderProps.values, onAutoSave: onAutoSave, autoSaveThrottleDelay: autoSaveThrottleDelay })); } }));
});
